export default function DarkBackgroundWrap({ children }) {
  return (
    <div className="p-8 absolute h-screen w-screen overflow-hidden grid justify-items-center items-center bg-gradient-to-br from-slate-900 to-slate-700 text-white">
      {children}
    </div>
  );
}
